var TaskCategories;
(function (TaskCategories) {
    TaskCategories["MANDATORY"] = "mandatory";
    TaskCategories["RECOMMENDED"] = "recommended";
})(TaskCategories || (TaskCategories = {}));
export default TaskCategories;



//////////////////
// WEBPACK FOOTER
// ./src/enums/TaskCategories.ts
// module id = 1917
// module chunks = 81